/** Bloque tipográfico Figma 1126:5516 — debajo del módulo layered-bottom. */
export default function PulseMoreFeaturedHeading() {
  return (
    <h2 className="pulse-more-featured-heading m-0">
      <span className="font-light">Más</span>
      <span className="font-bold"> Destacados</span>
    </h2>
  );
}
